// ChangePasswordPage.jsx
import React, { useState ,useEffect} from "react";
import { changePassword } from "./authService";

const ChangePasswordPage = () => {
  useEffect(() => {
    document.title = "Change Password | Workgear365";
  }, []);
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess("");

    if (form.new_password !== form.new_password_confirmation) {
      setErrors(["Passwords do not match."]);
      return;
    }

    try {
      await changePassword(form);
      setSuccess("Password changed successfully!");
      setForm({ current_password: "", new_password: "", new_password_confirmation: "" });
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(Object.values(err.response.data.errors).flat());
      } else {
        setErrors(["Password change failed."]);
      }
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow">
            <div className="card-header text-white">
              <h4 className="mb-0">Change Password</h4>
            </div>
            <div className="card-body p-4">
              {errors.map((e, i) => (
                <div key={i} className="alert alert-danger py-1">{e}</div>
              ))}
              {success && <div className="alert alert-success">{success}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Current Password</label>
                  <input
                    type="password"
                    name="current_password"
                    value={form.current_password}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">New Password</label>
                  <input
                    type="password"
                    name="new_password"
                    value={form.new_password}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Confirm Password</label>
                  <input
                    type="password"
                    name="new_password_confirmation"
                    value={form.new_password_confirmation}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Change Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
